import React from "react";
import "../Aboutus/Aboutus.css";
import About from "../About/About";
import Award from "./Award";
import Count from "./Count";
import { Link } from "react-router-dom";
const Aboutus = () => {
  return (
    <>
      <div className="about-us">
        <div className="overlay-a">
          <div className="text-container">
            <h1>Bring your next plants home</h1>
            <p>
              Find your dream plants for your home decorations with us, and we
              will make it happens...
            </p>
            <Link to="/contact">
              {" "}
              <button className="animated-button">Contact Us</button>
            </Link>
          </div>
        </div>
        <img
          src="about.webp" // Replace with your image URL
          alt="About Us Poster"
          className="poster-image"
        />
      </div>
      <About />
      <Award />
      <Count />
    </>
  );
};

export default Aboutus;
